import { identity } from 'ramda'
import React from 'react'

import InputWrapper from './InputWrapper'

const formatOptions = (options, t) => {
  return options.map(({ key, label, value, groupName, suboptions }) =>
    !!groupName ? (
      <optgroup key={groupName} label={groupName}>
        {formatOptions(suboptions)}
      </optgroup>
    ) : (
      <option key={key + label + value} value={value}>
        {t(label)}
      </option>
    )
  )
}

const Select = ({ options, disableEmptyOption, t, onChange, defaultOption, ...props }) => {
  t = t || identity

  const handleChange = e => {
    const newValue = !!e && !!e.target ? e.target.value : e
    if (onChange) onChange(newValue)
  }

  return (
    <InputWrapper inputOnTop iconSize=".9rem" iconRight="BsCaretDown" {...props}>
      <select className="input" onChange={handleChange} {...props}>
        {!disableEmptyOption && <option value={defaultOption || ''}> </option>}
        {formatOptions(options, t)}
      </select>
    </InputWrapper>
  )
}

export default Select
